import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";

interface VideoProps {
  videoPath: string;
  style?: React.CSSProperties;
  styleVideo?: React.CSSProperties;
  videoProps?: React.VideoHTMLAttributes<HTMLVideoElement>;
  play?: boolean;
  restart?: boolean;
  pageNumber: number;
}

const Video = ({ videoPath, style, styleVideo, videoProps, pageNumber }: VideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    if (pageNumber === currentPage) {
      videoElement.currentTime = 0;
      videoElement.play();
    } else {
      videoElement.pause();
    }

    return () => {
      videoElement.pause();
    };
  }, [pageNumber, currentPage]);

  return (
    <div style={style}>
      <video {...videoProps} style={styleVideo} ref={videoRef} src={require(`../../../Assets/videos/${videoPath}`)} />
    </div>
  );
};

export default Video;
